var _path, _path2, _path3, _path4, _path5, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#56aaff",
    d: "M24,4H4A3,3,0,0,0,1,7V21a2.87,2.87,0,0,0,.28,1.25,1,1,0,0,0,.76.56h.14a1,1,0,0,0,.75-.34l7-7.93,3.87,4.83a1,1,0,0,0,1.43.13L19,16.32l3.34,2.86a1,1,0,0,0,1.05.16,3.94,3.94,0,0,1,2.4-.26,1,1,0,0,0,1.2-1V7A3,3,0,0,0,24,4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0478ed",
    d: "M23.64,17.66l-4-3.42a1,1,0,0,0-1.3,0l-3.61,3.09-4-5A1,1,0,0,0,10,12a1,1,0,0,0-.77.34L1.43,21.16a1,1,0,0,0-.16,1.07A3,3,0,0,0,4,24H20a1,1,0,0,0,1-1,4,4,0,0,1,1.17-2.83,3.89,3.89,0,0,1,1.22-.83,1,1,0,0,0,.26-1.68Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.54,26.54a5,5,0,0,1-7.08-7.08,4.89,4.89,0,0,1,1.53-1,5,5,0,0,1,5.55,1A5,5,0,0,1,28.54,26.54Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#56aaff",
    d: "M25,29a6,6,0,0,1-4.25-10.24,6,6,0,0,1,8.49,0,6,6,0,0,1,0,8.49h0A6,6,0,0,1,25,29Zm0-10a4,4,0,0,0-2.82,1.17,4,4,0,0,0,0,5.67,4,4,0,1,0,5.66-5.67,3.9,3.9,0,0,0-2-1.08A4,4,0,0,0,25,19Zm3.55,7.54h0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#56aaff",
    d: "M21.46,27.54a1,1,0,0,1-.71-1.71l7.07-7.07a1,1,0,0,1,1.41,1.41l-7.07,7.07A1,1,0,0,1,21.46,27.54Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 10,
    r: 2,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no-image.8db90ef633acaa8b0a788a8a2f4f19f7.svg";
export { ForwardRef as ReactComponent };